(function () {
    "use strict";

    angular.module("app").factory("textValidators", TextValidatorsFactory);
    function TextValidatorsFactory() {
        return {
            IsValidKboNumber: isValidKboNumber,
            isValidBranchNumber,
            IsValidReferenceNumber: isValidReferenceNumber,
        };

        function isValidKboNumber(number) {
            if (!number)
                return false;

            const candidate = number.replace(new RegExp("[^(0-9)]", "g"), "");
            // Branch number
            if (number.startsWith("2"))
                return false;

            return isChecksumValid(candidate);
        }

        function isValidBranchNumber(number) {
            if (!number)
                return false;

            const candidate = number.replace(new RegExp("[^(0-9)]", "g"), "");
            // Branch numbers always start with 2
            if (!number.startsWith("2"))
                return false;

            return isChecksumValid(candidate);
        }

        function isValidReferenceNumber(referenceNumber, isBelgian) {
            const isBoolean = typeof isBelgian === 'boolean';
            if (!isBoolean)
                throw new Error("textValidators.IsValidReferenceNumber: the isBelgian parameter is required");

            // null or undefined is passed
            if (!referenceNumber)
                return false;

            const trimmed =  referenceNumber.trim();
            // only whitespace was present
            if (trimmed.length === 0)
                return false;
            
            // Foreign reference numbers are not validated
            if (!isBelgian)
                return true;
            
            const cleaned = getOnlyNumbers(referenceNumber);
            return cleaned.length === 11;
        }

        function getOnlyNumbers(value) {
            return value.replace(/[\D]/g, '').trim();
        }

        function isChecksumValid(number) {
            const numberWithoutModulo = number.substring(0, number.length - 2);
            const modulo = number - (numberWithoutModulo * 100);
            return 97 - (numberWithoutModulo % 97) == modulo && number.length == 10;
        }
    }
})();